export default __webpack_public_path__ + "2705d8aedbadc4bac6e7b985f5e7e1af.jpg";